import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GET_MONITOR_EVENTS_SUCCESS} from "../../constants/MonitorConstants";
import {GetMonitorAlertsCall} from "../../apis/monitor";
import {GENERIC_ERROR} from "../../constants/ErrorConstants";

function* tryFunction() {
    const response: Record<string, string> = yield call(GetMonitorAlertsCall);
    yield put({
        type: GET_MONITOR_EVENTS_SUCCESS,
        payload: response
    });
}


export function* getMonitorEventsSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}
